import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from './AuthContext';
import {
  setDemoMode as setModuleDemoMode,
  resetMasks,
  DEMO_ALLOWED_EMAILS,
} from '../utils/demoMode';

const DemoModeContext = createContext(null);

export const useDemoMode = () => {
  const context = useContext(DemoModeContext);
  if (!context) {
    return { isDemoMode: false, toggleDemoMode: () => {}, canAccessDemoMode: false };
  }
  return context;
};

export const DemoModeProvider = ({ children }) => {
  const { user, authEnabled } = useAuth();
  const canAccessDemoMode =
    !authEnabled || !!(user?.email && DEMO_ALLOWED_EMAILS.includes(user.email.toLowerCase()));

  const [isDemoMode, setIsDemoMode] = useState(() => {
    return sessionStorage.getItem('lexibridge_demo_mode') === 'true';
  });

  useEffect(() => {
    const effective = isDemoMode && canAccessDemoMode;
    setModuleDemoMode(effective);
    if (isDemoMode) {
      sessionStorage.setItem('lexibridge_demo_mode', 'true');
    } else {
      sessionStorage.removeItem('lexibridge_demo_mode');
    }
  }, [isDemoMode, canAccessDemoMode]);

  const toggleDemoMode = useCallback(() => {
    setIsDemoMode((prev) => {
      if (prev) resetMasks();
      return !prev;
    });
  }, []);

  const value = {
    isDemoMode: isDemoMode && canAccessDemoMode,
    toggleDemoMode,
    canAccessDemoMode,
  };

  return <DemoModeContext.Provider value={value}>{children}</DemoModeContext.Provider>;
};
